import { Container, ModalContent, Overlay } from './Modal.styles';

import { ActionButtons } from './ActionButtons';
import { Body } from './Body';
import { ESCAPE_KEY } from './constants';
import { FocusOn } from 'react-focus-on';
import { Header } from './Header';
import { ModalProps } from './types';
import { useEffect } from 'react';
import { useIframeDialogClamp } from 'features/common/hooks/useIframeDialogClamp';

const Modal = ({ children, className, onClose, isWide }: ModalProps) => {
	// Clamp to the parent's visible band when embedded, so this dark-theme base (used by legacy-punchup
	// in-iframe modals) fits the mobile fold instead of centering the card in the full content-height
	// iframe (TIC-636). `'fixed'` because the modal renders inline (Container is already position:fixed);
	// the card is capped in px from the raw band because the FocusOn wrapper breaks a percentage cap.
	// Standalone/desktop keep the CSS `vh` sizing (both are undefined).
	const { overlayStyle, viewport } = useIframeDialogClamp(true, 'fixed');

	function handKeyDown(event: { key: string }) {
		if (event.key === ESCAPE_KEY && onClose) {
			onClose();
		}
	}

	useEffect(() => {
		document.addEventListener('keydown', handKeyDown);
		return () => {
			document.removeEventListener('keydown', handKeyDown);
		};
	}, []);

	return (
		<Container style={overlayStyle}>
			<Overlay onClick={onClose} />
			<FocusOn>
				<ModalContent
					role="dialog"
					aria-modal="true"
					className={className}
					isWide={isWide}
					style={viewport ? { maxHeight: viewport.viewportHeight } : undefined}
				>
					{children}
				</ModalContent>
			</FocusOn>
		</Container>
	);
};
Modal.Header = Header;
Modal.Body = Body;
Modal.ActionButtons = ActionButtons;

export { Modal };
